import { useEffect, useState, useContext, useCallback } from "react";
import * as publicApi from "../../../service/publicApi";
import PageHeader from "../../pageheader/PageHeader";
import Breadcrumb from "../breacrumb/breadcrumb";
import { CurrentUserContext } from "../../../App";
import { RedirectCode400 } from "../../RedirectCode400";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import Pagination from "../pagination/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFile } from "@fortawesome/free-solid-svg-icons";

function Content({ slug, role }) {
  let params = useParams();
  const navigate = useNavigate();

  const { setIsMessage } = useContext(CurrentUserContext);

  const [titleName, setTitleName] = useState("");
  const [content, setContent] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [amount, setAmount] = useState(0);

  const pathItems = [
    { name: "หน้าหลัก", url: `${role ?? ""}/` },
    { name: titleName, url: `${role ?? ""}/news` },
  ];

  useEffect(() => {
    setPage(1);
  }, [params.slug]);

  const getContent = useCallback(
    async (newPage) => {
      let body = {
        page: newPage,
        number_per_page: 8,
      };

      let res = await publicApi.getFormSurveyList(body);

      if (res) {
        if (res["data"]["code"] === 200) {
          setContent(res["data"]["form_survey_list"]);
          setAmount(res["data"]["amount"]);
          setMaxPage(Math.ceil(res["data"]["amount"] / 8));
        } else if (res["data"]["code"] === 403) {
          navigate(RedirectCode400());
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    },
    [navigate, setIsMessage],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (params.slug === "form_survey" || slug === "form_survey") {
      setTitleName("แบบฟอร์มส่งตรวจเภสัชพันธุศาสตร์");
      getContent(page);
    } else {
      navigate(RedirectCode400());
    }
  }, [page, params.slug, slug, getContent, navigate]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={titleName} />

        {params.slug === "form_survey" && (
          <>
            <div>
              <div className="flex flex-col w-full bg-gray-200 gap-[2px]">
                {content.map((announcement, index) => (
                  <a
                    key={index}
                    className="flex flex-row w-full justify-between items-center gap-4 py-4 text-black bg-white cursor-pointer"
                    href={announcement.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="flex flex-row w-[10%] gap-1 justify-end items-start">
                      <span className="mt-1 px-4 py-1 text-[24px] text-black text-center rounded-[25px]">
                        <FontAwesomeIcon icon={faFile} />
                      </span>
                    </div>
                    <div className="xl:text-sm xl:px-5 pr-5 text-lg font-bold w-full text-start">
                      {announcement.name}
                    </div>
                    <span className="md:text-[11px] p-1 w-[10%] text-sm text-end text-nowrap text-[#000000]">
                      <span style={{ fontSize: "24px" }}>
                        <FontAwesomeIcon icon={faDownload} />
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
            <div className="flex justify-center mt-[20px]">
              {amount > 0 ? (
                <Pagination
                  page={page}
                  totalpage={maxPage}
                  clickForward={() => {
                    if (page < maxPage) {
                      setPage(page + 1);
                    }
                  }}
                  clickBackward={() => {
                    if (page > 1) {
                      setPage(page - 1);
                    }
                  }}
                  choosepage={handlePageChange}
                />
              ) : (
                "ไม่มีข้อมูล"
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Content;
